import { useStorage } from "../../utils/use-storage";

const columns_key = 'invoice_cols';

export type InvoiceCol = ('email' | 'agd_id');
export type InvoiceCols = InvoiceCol[];

const columns: {
    id: InvoiceCol;
    label: string;
}[] = [{
    id: 'email',
    label: 'Email',
},{
    id: 'agd_id',
    label: 'AGD ID',
},]

export const useInvoiceCols = () => {
    const {
        getKey,
        setKey,
    } = useStorage();
    const cols = getKey(columns_key, []) as InvoiceCols;
    const setCols = (v: InvoiceCols) => setKey(columns_key, v);

    const showColumn = (id: InvoiceCol) => {
        return cols.indexOf(id) > -1;
    }

    const toggleColumn = (id: InvoiceCol) => {
        if (!showColumn(id)) {
            setCols([
                ...cols, id,
            ]);
        } else {
            setCols(cols.filter(c => c !== id));
        }
    }

    return {
        cols,
        columns,
        setCols,
        showColumn,
        toggleColumn,
    };
}